import type { ProgressReport, ProgressReportPeriod } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from '../model/store/interfaces'

import { getReport } from './report'

export const getPeriodLabel = (report: Pick<ProgressReport, 'period'> | null): string => {
  const period = report?.period

  if (!period) return ''

  return `${period.from} – ${period.to}`
}

export const period = {
  getPeriod: (state: ProgressReportStore): ProgressReportPeriod | null => getReport(state)?.period || null,
  getPeriodLabel: (state: ProgressReportStore): string => getPeriodLabel(getReport(state)),
}
